import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { bodyMicroText, colors, transition } from '#/theme/theme';

export const CartDropdownButtonCountAndIconHolder = styled.div`
  display: flex;
  align-items: center;
`;

export const CartDropdownButtonMenuItemEmptyMessage = styled.div`
  color: ${colors.lightContentGrey};
  padding: 5px 10px;
  ${bodyMicroText};
  border-bottom: 1px solid ${colors.calloutGrey};
`;

export const CartDropdownButtonCount = styled.span`
  width: 12px;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
`;

export const CartDropdownButtonMenuItemLink = styled(
  StyledVersionedRouterLink,
)<{
  $isSelected?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  color: ${colors.lightContentGrey};
  transition: ${transition};
  font-size: 14px;
  font-weight: 400;
  user-select: none;
  background: ${(props) =>
    props.$isSelected ? colors.softBlue : 'transparent'};

  &:hover {
    color: ${colors.lightContentGrey};
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;

export const CartDropdownButtonMenuItemPostLink = styled(
  StyledVersionedRouterLink,
)`
  color: ${colors.lightContentGrey};
  padding: 5px 10px;
  ${bodyMicroText};
  transition: ${transition};
  user-select: none;
  width: 100%;
  display: flex;

  &:hover {
    text-decoration: none;
    background: ${colors.calloutGrey};
  }
`;

export const CartDropdownButtonMenuItemCount = styled.span`
  background: ${colors.brandBlue};
  transition: ${transition};
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  font-size: 11px;
`;
